/*
    Here place for import global component that can also be called on the blade
*/

import Vue from "vue";

const vueSideBar = () => import("./components/global/sidebar.vue");
const vueToolbar = () => import("./components/global/toolbar.vue");
const checkAccess = () => import("./components/global/loadAccess.vue");
const headerTitle = () => import("./components/global/headerTitle.vue");
const headerTitle2 = () => import("./components/global/headerTitle2.vue");
const assignAccess = () => import("./components/global/assignAccess.vue");
const exportProgressBubble = () => import("./components/global/exportProgressBubble.vue");

Vue.component("vue-sidebar", vueSideBar);
Vue.component("vue-toolbar", vueToolbar);
Vue.component("check-access", checkAccess);
Vue.component("header-title", headerTitle);
Vue.component("header-title2", headerTitle2);
Vue.component("assign-access", assignAccess);
Vue.component("export-progress-bubble", exportProgressBubble);